export { default } from './PrefilteredTravelsBlock'
